module.exports = {"TXTWCL_Continue":{"id":"TXTWCL_Continue","defaultMessage":"Continuer","track":"Continue"}}